"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var alignTypes = exports.alignTypes = ["top", "topRight", "topLeft", "right", "rightTop", "rightBottom", "bottom", "bottomRight", "bottomLeft", "left", "leftTop", "leftBottom"];

var alignTypesSet = new Set(alignTypes);

var alignFixedPositionElement = exports.alignFixedPositionElement = function alignFixedPositionElement() {
  var align = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "bottom";
  var $fixedElement = arguments[1];
  var rect = arguments[2];
  var gapFromContainer = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  if (!rect) return null;

  var alignHorizontalMiddle = "\n      left: " + (rect.left + rect.width / 2) + "px;\n      margin-left: -" + $fixedElement.offsetWidth / 2 + "px;\n    ";

  var alignVerticalMiddle = "\n      top: " + (rect.top + rect.height / 2) + "px;\n      margin-top: -" + $fixedElement.offsetHeight / 2 + "px;\n    ";

  var alignOuterTop = "top: " + (rect.top - gapFromContainer - $fixedElement.offsetHeight) + "px;";
  var alignInnerTop = "top: " + rect.top + "px;";
  var alignOuterRight = "left: " + (rect.width + gapFromContainer + rect.left) + "px;";
  var alignInnerRight = "left: " + (rect.width + rect.left - $fixedElement.offsetWidth) + "px;";
  var alignOuterBottom = "top: " + (rect.top + gapFromContainer + rect.height) + "px;";
  var alignInnerBottom = "top: " + (rect.height + rect.top - $fixedElement.offsetHeight) + "px;";
  var alignOuterLeft = "left: " + (rect.left - gapFromContainer - $fixedElement.offsetWidth) + "px;";
  var alignInnerLeft = "left: " + rect.left + "px;";
  var alignOptions = {};

  alignOptions.top = alignOuterTop + " " + alignHorizontalMiddle;
  alignOptions.topRight = alignOuterTop + " " + alignInnerRight;
  alignOptions.topLeft = alignOuterTop + " " + alignInnerLeft;

  alignOptions.right = alignVerticalMiddle + " " + alignOuterRight;
  alignOptions.rightTop = alignInnerTop + " " + alignOuterRight;
  alignOptions.rightBottom = alignInnerBottom + " " + alignOuterRight;

  alignOptions.bottom = alignOuterBottom + " " + alignHorizontalMiddle + " ";
  alignOptions.bottomRight = alignOuterBottom + " " + alignInnerRight;
  alignOptions.bottomLeft = alignOuterBottom + " " + alignInnerLeft;

  alignOptions.left = alignVerticalMiddle + " " + alignOuterLeft;
  alignOptions.leftTop = alignInnerTop + " " + alignOuterLeft;
  alignOptions.leftBottom = alignInnerBottom + " " + alignOuterLeft;

  if (align && alignTypesSet.has(align)) {
    return alignOptions[align];
  }

  // this test for align="" and return default alignment
  return alignOptions[align];
};